import React, { useEffect, useState } from 'react'
import ProductSection from '../../components/common/ProductsSection'
import ArrowRightIcon from '../../assets/icons/ArrowRightIcon'
import ArrowDown from '../../assets/icons/ArrowDown'
import MainFilter from '../../components/filter_product/MainFilter'
import PageTitle from '../../components/common/PageTitle'
import ProductCard from '../../components/cards/ProductCard'
import WhyUsSection from '../../components/common/WhyUsSection'
import OurMissionSection from '../../components/common/OurMissionSection'
import { useDispatch, useSelector } from 'react-redux'
import { getProducts } from '../../services/actions/MainAction'
import CloseIcon from '../../assets/icons/CloseIcon'

function Products() {
     const [modalVisible, setModalVisible] = useState("");
    const contentData = useSelector(state => state.Data.contentData);
    const lang_id = useSelector(state => state.Data.lang_id);
    const productsData = useSelector(state => state.Data.productsData);
    const dispatch = useDispatch();
    useEffect(()=>{
      dispatch(getProducts(lang_id));
      window.scrollTo(0,0)
    },[lang_id])
  
  return (
    <main className='w-full min-h-[115vh]'>
      <PageTitle title={contentData?.olcme_avad} />
      <div className='container2'>
        <div className='grid grid-cols-3 gap-[40px]  relative mt-[30px] max-[1200px]:grid-cols-2 gap-y-[20px] max-[800px]:grid-cols-2 max-[500px]:grid-cols-1 gap-y-[0px]'>
          {
            productsData?.map((data, i)=>{
              return (
                <ProductCard onOpen={()=>setModalVisible(data?.image_full_url)} key={i} data={data} />
              )
            })
          }
        </div>
      </div>
      {
            modalVisible !==""?
            <div className="bg-black/70 fixed top-0 left-0 w-full h-screen flex items-center justify-center z-[1000] ">
                <button  onClick={()=>setModalVisible("")} className="absolute right-[30px] top-[30px]">
                    <CloseIcon />
                </button>
                <div className="max-w-[700px] h-auto max-h-[60vh] bg-[red] ">
                    <img className="max-w-full max-h-[60vh]" src={modalVisible} />
                </div>
            </div>:null
        }
    </main>
  )
}

export default Products
